import { render } from "./ViewMenu.vue?vue&type=template&id=787fbb0e&scoped=true"
import script from "./ViewMenu.vue?vue&type=script&lang=js"
export * from "./ViewMenu.vue?vue&type=script&lang=js"

import "./ViewMenu.vue?vue&type=style&index=0&id=787fbb0e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787fbb0e"],['__file',"src/components/view/ViewMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "787fbb0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('787fbb0e', __exports__)) {
    api.reload('787fbb0e', __exports__)
  }
  
  module.hot.accept("./ViewMenu.vue?vue&type=template&id=787fbb0e&scoped=true", () => {
    api.rerender('787fbb0e', render)
  })

}


export default __exports__